export const ENTITY_STATUS_OPTIONS = [
  { value: "large", label: "Large" },
  { value: "small", label: "Small" },
  { value: "micro", label: "Micro" },
];

const ENTITY_STATUS_LABELS = ENTITY_STATUS_OPTIONS.reduce((acc, option) => {
  acc[option.value] = option.label;
  return acc;
}, {});

const toTitleCase = (value) =>
  value
    .split(/[\s_-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");

export const normalizeEntityStatus = (value) => {
  if (value === null || value === undefined) {
    return "";
  }

  const normalized = String(value).trim().toLowerCase();
  return normalized;
};

export const formatEntityStatus = (value, fallback = "N/A") => {
  const normalized = normalizeEntityStatus(value);

  if (!normalized) {
    return fallback;
  }

  return ENTITY_STATUS_LABELS[normalized] || toTitleCase(normalized);
};

export const matchesEntityStatusFilter = (value, filterValue) => {
  const normalizedFilter = normalizeEntityStatus(filterValue);

  if (!normalizedFilter) {
    return true;
  }

  return normalizeEntityStatus(value) === normalizedFilter;
};

export const getEntityStatusValue = (record = {}) =>
  record.entityStatus || record.entityType || record.entity_type || "";
